
import { Component, Vue } from "vue-property-decorator";
import StartDate from "@/components/StartDate.vue";
import Partners from "@/components/Partners.vue";
import Menu from "@/components/Menu.vue";
@Component({
  components: { Menu, Partners, StartDate },
})
export default class Footer extends Vue {}
